import { useContext } from 'react';
// import LoadingScreen from 'components/LoadingScreen';
import { getSession } from 'utils/jwt';
import { AuthContext } from "context/AuthContext";

export const PATH = {
    root: "/",
    login: "/Auth/Login",
    register: "/Auth/Register",

    sales: "/Transaction/Sales",
    expenses: "/Transaction/Expenses",

};

export const enabledRoute = () => { 
    let returnValue = []
    try {
      const user = getSession();
      // const { user } = useContext(AuthContext);
      
      // console.log("user.enabled_module",user.enabled_module);
      let role = {}
      
      if(!!(user?.enabled_module) && typeof(user?.enabled_module) === "string"){
        role = JSON.parse(user.enabled_module);
      }else if(user?.enabled_module){
        role = user.enabled_module;
      }
      // console.log("enabledRoute", role)

      function loopThroughObjectData(objectData) {
        let itemsValue = [];
        Object.keys(objectData).forEach((key) => {
          // console.log(objectData[key]);
          
          if ( objectData[key].hasOwnProperty('children')){
            let obj = {
              title : `${objectData[key].label}`,
              path: `/${key}` , 
              icon: objectData[key].icon,
              children : loopThroughObjectData(objectData[key].children) ,
            //   icon: switchIcon(key) ,
            }
            
            if( obj.children?.length > 0 ){ 
              itemsValue.push(obj);
            }
          }else if( objectData[key]?.action.R === true ){ // CAN READ
            itemsValue.push({ 
              title: `${objectData[key].label}`, 
              path: `/${key}` ,
              icon: objectData[key].icon,
              // icon: switchIcon(key) ,
            })
          }
          
        })
        return itemsValue;
      }
      
      returnValue = loopThroughObjectData(role);
    } catch (error) {
      console.log(error);
      returnValue = []
    }
    // console.log("enabledRoute returnValue" , returnValue);
    return returnValue 
}
